export default __webpack_public_path__ + "static/media/party-img.e9d143f4.jpeg";